var _excluded = ["className", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import CkIcon from "../private/CkIcon";
import { nanoid } from "nanoid/non-secure";
var LinkedinLg = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _props = _extends({}, props),
    {
      className,
      title
    } = _props,
    rest = _objectWithoutPropertiesLoose(_props, _excluded);
  var titleId = props != null && props.id ? props.id + "-title" : nanoid(5);
  return /*#__PURE__*/React.createElement(CkIcon, _extends({
    className: ["CK__Icon--large", className].filter(Boolean).join(" "),
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": title ? titleId : undefined
  }, rest), title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.027 9H13l.05 1.467h.057C13.66 9.417 14.984 8.5 17 8.5c4.196 0 5 2.402 5 6V22h-4v-6.607c0-1.55-.373-3.393-2.5-3.393-2.156 0-2.5 1.65-2.5 3.393V22H9.027V9ZM4.404 2a2.406 2.406 0 0 1 2.402 2.408 2.406 2.406 0 0 1-2.402 2.408A2.405 2.405 0 0 1 2 4.408 2.405 2.405 0 0 1 4.404 2ZM2.5 22h4V9h-4v13Z",
    fill: "currentColor"
  }));
});
LinkedinLg.displayName = "LinkedinLg";
export default LinkedinLg;